module.exports = __webpack_public_path__ + "static/media/imga_bg.9d7dc328.png";